import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
window.Pusher = Pusher;

// Enable Pusher debugging
window.Pusher.logToConsole = import.meta.env.VITE_DEBUG === 'true';

export default new Echo({
    broadcaster: 'pusher',
    key: import.meta.env.VITE_ECHO_APP_KEY,
    wsHost: import.meta.env.VITE_ECHO_HOST,
    wsPath: import.meta.env.VITE_ECHO_PATH ?? "/ws",
    wsPort: import.meta.env.VITE_ECHO_PORT ?? 443,
    wssPort: import.meta.env.VITE_ECHO_PORT ?? 443,
    forceTLS: true,
    cluster: "",
    enabledTransports: ['ws', 'wss'],
    encrypted: false,
    authEndpoint: '/broadcasting/auth',
});
